const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  withdrawalState: state => state.app.withdrawalState,
  commissionState: state => state.app.commissionState,
  orderState: state => state.app.orderState,
  chargeOrderState: state => state.app.chargeOrderState,
  onlineType: state => state.app.onlineType,
  wifiModels: state => state.settings.wifiModels,
  withdrawalMethod: state => state.settings.withdrawalMethod,
  withdrawalDayTimes: state => state.settings.withdrawalDayTimes,
  withdrawalMinAmount: state => state.settings.withdrawalMinAmount,
  withdrawalMaxAmount: state => state.settings.withdrawalMaxAmount,
  withdrawalHandMinAmount: state => state.settings.withdrawalHandMinAmount,
  aliPay: state => state.settings.aliPay,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  loginMode: state => state.user.loginMode,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  agentId: state => state.user.agentId,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  assignCards: state => state.assigncard.assignCards,
  orderCards: state => state.batchbuy.orderCards,
  orderGoodsGroupId: state => state.batchbuy.goodsGroupId,
  goodsType: state => state.goods.goodsType,
  temporaryType: state => state.goods.temporaryType,
  effectiveDuration: state => state.goods.effectiveDuration,
  operatorType: state => state.goods.operatorType,
  cardState: state => state.card.cardState,
  wifiOrderState: state => state.app.wifiOrderState,
  wifiOrderWay: state => state.app.wifiOrderWay,
  deliveryState: state => state.app.deliveryState,
  finishType: state => state.app.finishType,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js